import { Buffer } from "buffer";
import { useNavigate } from "react-router-dom";
import { getLocalStorageItem } from "../../utils/localstorage";
import { useQuery } from "./use-query";

export const DEFAULT_PATH = "/";
export const DEFAULT_BETAPATH = "/beta";

export const useReturnUrl = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const hashedReturnUrl = query.get("returnUrl") ?? "";

  const returnUrl =
    hashedReturnUrl !== "" && hashedReturnUrl !== "null"
      ? Buffer.from(hashedReturnUrl, "base64").toString()
      : getLocalStorageItem("beta") === "true"
      ? DEFAULT_BETAPATH
      : DEFAULT_PATH;

  const returnToPreviousUrl = () => {
    if (returnUrl === DEFAULT_PATH) navigate(returnUrl);
    else if (returnUrl === DEFAULT_BETAPATH) navigate(returnUrl);
    else window.location.assign(returnUrl);
  };

  return { returnUrl, hashedReturnUrl, returnToPreviousUrl };
};
